import { apiHelper } from '@/utils/api.helper'

export const REVIEW = {
  getMyReview,
  submitReview,
  getReviewList
}

const URL = {
  REVIEW: 'review',
  MY_REVIEW: 'myreviews',
  SUBMIT_REVIEW: 'create',
  REVIEW_LIST: 'reviews'
}

function getMyReview(params) {
  return apiHelper().get(`${URL.REVIEW}/${URL.MY_REVIEW}`, { params })
}

function submitReview(params) {
  return apiHelper().post(`${URL.REVIEW}/${URL.SUBMIT_REVIEW}`, null, { params })
}

function getReviewList(params) {
  return apiHelper().get(`${URL.REVIEW}/${URL.REVIEW_LIST}`, { params })
}
